/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GenericSnapshotData } from '../models/GenericSnapshotData';

export class CloudSnapshotsPerVolume {
  /**
  * The provider volume ID of the snapshots.
  */
  'providerVolumeId'?: string;
  'snapshotsData'?: Array<GenericSnapshotData>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "snapshotsData",
      "baseName": "snapshotsData",
      "type": "Array<GenericSnapshotData>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CloudSnapshotsPerVolume.attributeTypeMap;
  }

  public constructor() {
  }
}

